import React from 'react'
import { MultimediaUploaderType } from '../../../../../../../@types/multimedia-types'
import MultimediaButtonProvider from './buttonWrapper/MultimediaButtonProvider'
import { isWebView } from '../../../../../../../utils/navigation'

export interface MultimediaButtonsTypes {
  hasButtonBigSize: boolean
  allowedMediaTypes: MultimediaUploaderType[]
}

const MultimediaButtons: React.FC<MultimediaButtonsTypes> = ({ hasButtonBigSize, allowedMediaTypes }) => {
  const getWrapperClassByMediaType = (mediaType: MultimediaUploaderType) => {
    const hasOneButton = allowedMediaTypes.length === 1
    if (hasButtonBigSize) {
      if (mediaType === MultimediaUploaderType.DOCUMENT) {
        return `grid-item ${
          allowedMediaTypes.includes(MultimediaUploaderType.VIDEO)
            ? 'one-half padding-right-m palm-padding-none'
            : 'one-whole palm-margin-top-l padding-right-m'
        }  palm-one-whole margin-top-m`
      } else {
        return `grid-item
        ${hasOneButton ? 'one-whole' : 'one-half'}
        ${isWebView() ? '' : 'padding-right-m'}
        palm-one-whole  palm-padding-none margin-top-m`
      }
    } else {
      return 'grid-item one-half'
    }
  }

  const hasOnlyPictures = allowedMediaTypes.includes(MultimediaUploaderType.PICTURE) && allowedMediaTypes.length === 1

  return (
    <>
      {isWebView() && hasOnlyPictures ? (
        <div
          className={getWrapperClassByMediaType(MultimediaUploaderType.PICTURE)}
          key={MultimediaUploaderType.PICTURE}
          data-testid={MultimediaUploaderType.PICTURE}
        >
          <MultimediaButtonProvider allowedFileType={MultimediaUploaderType.PICTURE} isFloorPlan={false} />
        </div>
      ) : (
        allowedMediaTypes.map((type) => (
          <div className={getWrapperClassByMediaType(type)} key={type} data-testid={type}>
            <MultimediaButtonProvider allowedFileType={type} isFloorPlan={type === MultimediaUploaderType.FLOOR_PLAN} />
          </div>
        ))
      )}
    </>
  )
}

export default MultimediaButtons
